import React from 'react';
import './Class.css';
import abacus from '../../Images/Abacus.png';
import {Helmet} from "react-helmet";

const Abacus = () => (
  <div className="explore-container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Brain-O-Meter - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    {/* Back Button */}
    <button className="back-button" onClick={() => window.history.back()}>
      ← Back
    </button>

    {/* Lakshya Card (Right Side, Above Header) */}
    <div className="lakshya-card">
      <img
        src={abacus} 
        loading="lazy"
        alt="abacus"
        className="lakshya-image"
      />
      <div className="course-details">
  
  <p className="pricing">💼 Fees for Full Course: ₹ 4999/- <br/><span style={{ fontSize: "0.8em", color: "#555" }}>Including Kit</span></p>
  
  <a href="https://rzp.io/rzp/Brain-O-Meter" target="_blank" rel="noopener noreferrer">
    <button className="buy-button">Buy Now</button>
  </a>
</div>

    </div>

    {/* Lakshya Header (Full Width) */}
    <div className="lakshya-header">
      <div className="lakshya-header-content">
        <h2 className="lakshya-title">Brain-<span className='highlight'>O</span>-Meter (Class-<span className='highlight'>1-6</span>)</h2>
      </div>
    </div>

    {/* Batch Details Section */}
    <div className="batch-details">
      <h3>Description</h3>
      <ul>
  <li><strong>1️⃣Basics of Abacus</strong>  
    <ul>
      <li>🔢Introduction to the world of numbers and counting with the Abacus.
      </li>
    </ul>
  </li>
  <li><strong>2️⃣Mental Arithmetic</strong>  
    <ul>
      <li>🧠Training the brain to solve problems faster and more accurately, without the use of a calculator.
      </li>
    </ul>
  </li>
  <li><strong>3️⃣Regular practice</strong>  
    <ul>
      <li>🕑Two interactive sessions per week with practical examples and fun activities.
      </li>
    </ul>
  </li>
  <li><strong>4️⃣Progress Tracking</strong>  
    <ul>
      <li>📈Continuous assessments to ensure your child’s improvement with personalized feedback.
      </li>
    </ul>
  </li>
  <li><strong>5️⃣24/7 Doubt-Solving</strong>  
    <ul>
      <li>💬Your child will have access to 24/7 support to clear any questions or doubts that may arise during their learning.</li>
    </ul>
  </li>
  <li><strong>6️⃣Reward System</strong>  
    <ul>
      <li>🏆Encouraging progress with badges, prizes, and special rewards for outstanding performance.
      </li>
    </ul>
  </li>
  <li><strong>7️⃣Fun and Engaging</strong>  
    <ul>
      <li>🎉Making math fun with games, quizzes, and interactive activities.
      </li>
    </ul>
  </li>
  <li><strong>8️⃣ Kit will also be provided</strong>  
          <ul>
            <li>🎁 Each participant will receive a complete Abacus kit to enhance their learning experience.</li>
          </ul>
        </li>
  <li><strong>📩 Have Questions?</strong>  
    <ul>
      <li>Reach out to us at <a href="mailto:support@ottertutors.com">support@ottertutors.com</a></li>
    </ul>
  </li>
  <br/>
  <li><strong>🚀 Join <span className='highlight1'>'Brain-O-Meter'</span> Take the first step towards academic success!</strong>  
  </li>
</ul>


    </div>

    {/* FAQ Section */}
    <div className="faq-section">
      <h2>FAQs</h2>
      <p style={{ textAlign: 'center' }}>
  Here are some of the frequently asked questions:
</p>
<div className="faq-grid">
  <div className="faq-item">
    🎯
    <div>
      <h3>Who Should Join This Batch?</h3>
      <p>
      🎓 Brain-o-meter is perfect for Class 1-6 students who are looking to enhance their mathematical skills and boost their mental agility through the fun and interactive method of Abacus learning.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Where Will the Classes Be Held?</h3>
      <p>
        💻 Classes will be conducted on Zoom, and links will be shared via WhatsApp groups for easy access.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>How Can I Get Help If I Have Doubts?</h3>
      <p>
      💬 24/7 doubt-solving support is available for students to clarify their doubts at any time. You can reach out through the provided contact options.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>What If I Miss a Class?</h3>
      <p>
      📼 Don’t worry! All classes are recorded, so you can watch them later to catch up on any missed content.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Are Tests and Quizzes Mandatory?</h3>
      <p>
      ✅ Yes! Weekly tests and live quizzes will help track your child’s progress and enhance their learning experience.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>How Does Abacus Benefit My Child?</h3>
      <p>
      🧠 Abacus learning boosts memory, concentration, problem-solving skills, and mental arithmetic. It helps improve a child’s overall cognitive development while making learning math fun and interactive.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Can I Get a Refund After Batch Purchase?</h3>
      <p>
      💡 Refunds are not available after batch purchase, as we invest in providing the best resources and infrastructure for an excellent learning experience. Please make a careful decision before purchasing the batch.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>What Is the Duration of Each Class?</h3>
      <p>
      ⏰ Each class will be 1 hour long with two interactive sessions per week to ensure consistent progress.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>How Do I Know My Child’s Progress?</h3>
      <p>
      📈 Regular assessments and personalized feedback will help track your child's development, ensuring they are progressing well in their Abacus skills.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Is Brain-o-meter Suitable for Beginners?</h3>
      <p>
      🌱 Absolutely! Brain-o-meter is designed for beginners and is divided into levels that help your child start from the basics and move on to more advanced techniques as they progress.
      </p>
    </div>
  </div>
</div>
</div>
  </div>
);

export default Abacus;
